/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconActivityHeartbeat = createReactComponent("outline", "activity-heartbeat", "IconActivityHeartbeat", [["path", { "d": "M3 12h4.5l1.5 -6l4 12l2 -9l1.5 3h4.5", "key": "svg-0" }]]);

export { IconActivityHeartbeat as default };
//# sourceMappingURL=IconActivityHeartbeat.mjs.map
